export const SET_LOCATION_SUCCESS = 'move-single-board-dialog/SET_LOCATION_SUCCESS';
export const SET_LOCATION_FAILURE = 'move-single-board-dialog/SET_LOCATION_FAILURE';
